// A served model's fallbacks (SCR-586, REQ-234): the line under its name in the by-model table —
// "38 requests fell back from Opus 5.5" — with every family and its count on hover, and the Fell
// back cell ("—" for none). Families are named by their display names (model.ts `fallbackText`).
import { formatCount } from "./figures";
import { fallbacksTitle, fallbackText, type ModelFallbacks } from "./model";

/** The line under a model's name; nothing when it served no fallback. */
export function FallbacksLine({ fallbacks }: { fallbacks: ModelFallbacks | null }) {
  const text = fallbacks && fallbackText(fallbacks);
  if (!fallbacks || !text) return null;
  return (
    <span class="cell-sub" title={fallbacksTitle(fallbacks)}>
      {text}
    </span>
  );
}

/** The Fell back column's cell: the count, or "—" when the model served none. */
export function fallbackCount(fallbacks: ModelFallbacks | null): string {
  return fallbacks && fallbacks.requests > 0 ? formatCount(fallbacks.requests) : "—";
}
